var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"mb-2 text-sm"},[_vm._v(" "+_vm._s(_vm.$t( 'settings-layout.menu-data.plugins.advanced-settings.drawer.menu.access.description', ))+" ")]),_c('plugin-access-settings-drawer',{attrs:{"title":_vm.$t(
        'settings-layout.menu-data.plugins.advanced-settings.drawer.menu.access.action',
      ),"accessRestrictionsIds":_vm.currentPlugin.accessRestrictions},on:{"update-access-restriction":_vm.handleUpdateAccessRestriction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }